export const ACTION_GET_BALANCE_BY_ID = '/OsimCart/InitializeBalanceCart';